import { RootState } from "@/app/stores";
import { IListInvoicesResult, listInvoices, cancelInvoice as cancel } from "@/shared/api/invoices";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchInvoices = createAsyncThunk<
    IListInvoicesResult,
    void,
    { state: RootState }
>('invoices/fetchInvoices', async(_, thunkAPI) => {
    try {
        const { page, limit } = thunkAPI.getState().invoices
        const data = await listInvoices(page, limit)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const cancelInvoice = createAsyncThunk<
    void,
    number,
    { state: RootState }
>('invoices/cancelInvoice', async(id, thunkAPI) => {
    try {
        const data = await cancel(id)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})